import React from 'react';
import 'react-tooltip/dist/react-tooltip.css';
import { Formik, Form } from 'formik';
import ToggleButton from '@/components/forms/toggle_button';
import styles from './BirthdaysForm.module.css';

interface Props {
    readonly onChange: (id: any, ignoreBirthday: any, record: any) => Promise<void>;
    readonly record: any;
    readonly picture?: string

}

function IgnoreToggle({
    onChange,
    record,
    picture = '/images/default-gravatar.svg',

}: Props) {
    return (
        <div className={styles.ignoreContainer}>
            <div className={styles.ignoreInnerContainer}>
                <img className="h-[32px] w-[32px]" src={record.photoImageUrl || picture} alt={record.displayName} />
                <span className={styles.ignoreNameLabel}>
                    {' '}
                    {record.displayName}
                </span>
            </div>
            <div className={`${styles.ignoreInnerContainer} mt-[20px] sm:mt-0`}>
                <div>
                    <Formik
                        onSubmit={() => { }}
                        initialValues={{

                        }}
                    >
                        <Form>
                            <ToggleButton
                                onChange={() => onChange(
                                    record.id,
                                    !record.ignoreBirthday,
                                    record || null,
                                )}
                                checked={record.ignoreBirthday}
                                name={record.displayName}
                            />
                        </Form>
                    </Formik>
                </div>
                <div>
                    <span className="text-[14px] font-normal">{record.ignoreBirthday ? ' Ignored' : ' Allowed'}</span>
                </div>
            </div>

        </div>
    );
}

export default IgnoreToggle;
